<div class="row">
    <div class="col-12">
        <nb-card accent="primary">
            <nb-card-header>
                {{'imprint_title' | translate }}
            </nb-card-header>
            <nb-card-body *ngIf="currentLanguageCode =='de'">
                <strong>ethinking GmbH</strong><br/><br/>
                <address>
                    Rosenstraße 19<br>
                    10178 Berlin<br>
                    <a href="mailto:info@ethinking.de">info@ethinking.de</a>
                    <p>
                        <a href="http://ethinking.de" target="_blank" title="ethinking.de" rel="noopener noreferrer">ethinking.de</a>
                    </p>
                </address>
                <p>Registergericht: Amtsgericht Berlin Charlottenburg</p>
                <p>Registernummer: HRB 159978 B</p>
                <p>Umsatzsteuer-Identifikationsnummer gem. § 27a UStG: DE295687902</p>
                <p>Vertretungsberechtigte Geschäftsführer: Simon Mieth, Christian Müller</p>
                <p>Inhaltlich Verantwortlicher Christian Müller (Anschrift s.o.)</p>
            </nb-card-body>

            <nb-card-body *ngIf="currentLanguageCode =='en'">
                <strong>ethinking GmbH</strong><br/><br/>
                <address>
                    Rosenstraße 19<br>
                    10178 Berlin<br>
                    Germany<br>
                    <a href="mailto:info@ethinking.de">info@ethinking.de</a>
                    <p>
                        <a href="http://ethinking.de" target="_blank" title="ethinking.de" rel="noopener noreferrer">ethinking.de</a>
                    </p>
                </address>
                <p>Commercial Registration: Amtsgericht Berlin Charlottenburg HRB 159978 B</p>
                <p>VAT Reg No: DE295687902</p>
                <p>Managing Director: Simon Mieth, Christian Müller</p>
                <p>Responsible for contents: Christian Müller (address above)</p>
            </nb-card-body>
        </nb-card>
    </div>
</div>
